<div class="wrapper">
  @if (crawledDocumentMetadata().length) {
    <div class="grid-2-columns align-items-start justify-content-start">
      @for (meta of crawledDocumentMetadata(); track meta._id; let idx = $index) {
        @if (idx <= limit()) {
          @switch (meta.type) {
            @case (MetadataType.CRAWLER_URL) {
              <app-metadata-cell class="h-100" [class.border-left]="$odd">
                <p label class="text light mb-8 fx-flex-100">
                  {{ 'DOCUMENT.' + meta.type | translate }}
                </p>
                <div class="fx-row align-items-center justify-content-start fx-flex-100">
                  <a [href]="meta.value" target="_blank">{{ meta.value }}</a>
                </div>
              </app-metadata-cell>
            }
            @case (MetadataType.CRAWLER_SCREENSHOT_DATE) {
              <app-metadata-cell class="h-100" [class.border-left]="$odd">
                <p label class="text light mb-8 fx-flex-100">
                  {{ 'DOCUMENT.' + meta.type | translate }}
                </p>
                <div class="fx-row align-items-center justify-content-start fx-flex-100">
                  <time
                    [dateTime]="meta.value"
                    [matTooltipClass]="{ 'uzai-tooltip': true }"
                    [matTooltip]="toISODate(meta.value)">
                    {{ toReadableDate(meta.value) }}
                  </time>
                </div>
              </app-metadata-cell>
            }
            @case (MetadataType.CRAWLER_SSL_CERTIFICATE) {
              @if (sslCertByMetaId()[meta._id!]; as cert) {
                <app-metadata-ssl-certificate class="grid-col-span-2" [cert]="cert" />
              }
            }
            @default {
              <app-metadata-cell class="h-100" [class.border-left]="$odd">
                <p label class="text light mb-8 fx-flex-100">
                  {{ 'DOCUMENT.' + meta.type | translate }}
                </p>
                <div class="fx-row align-items-center justify-content-start fx-flex-100">
                  <p>{{ meta.value }}</p>
                </div>
              </app-metadata-cell>
            }
          }
        }
      }
    </div>
  }
  @if (showToggle()) {
    <div class="fx-row w-100 align-items-center justify-content-end mt-10 clickable">
      <span class="text main" (click)="toggle()">
        {{ (isExpanded() ? 'UTILS.SEE_LESS' : 'UTILS.SEE_MORE') | translate }}
      </span>
      <mat-icon class="main ml-5" fontSet="material-icons-outlined">
        {{ isExpanded() ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
      </mat-icon>
    </div>
  }
</div>
